import { getThemeData } from '@hzero-front-ui/core';
import { css } from 'styled-components';
var C7nSwitchStyle = function C7nSwitchStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    primary = _getThemeData.primary;
  var _getThemeData2 = getThemeData(props, 'switch'),
    labelBgColor = _getThemeData2.labelBgColor,
    labelAfterBgColor = _getThemeData2.labelAfterBgColor,
    defaultSize = _getThemeData2.defaultSize,
    smSize = _getThemeData2.smSize,
    lgSize = _getThemeData2.lgSize;
  return css(["form .c7n-pro-switch-wrapper input[type='checkbox']{width:unset;height:unset;}.c7n-pro-switch-wrapper{&&&{.c7n-pro-switch-label{min-width:", "px;height:", "px;line-height:", "px;background-color:", ";border-radius:", "px;::after{width:", "px;height:", "px;left:1px;background-color:", ";}}.c7n-pro-switch:checked + .c7n-pro-switch-label,.c7n-pro-switch:checked + .c7n-progress-loading + .c7n-pro-switch-label{background-color:", ";::after{left:calc(100% - 1px);transform:translateX(-100% + 1px);background-color:", ";}}.c7n-progress-loading{.c7n-progress-inner circle{stroke:", ";}}&.c7n-pro-switch-sm{.c7n-pro-switch-label{min-width:", "px;height:", "px;line-height:", "px;::after{width:", "px;height:", "px;}}}&.c7n-pro-switch-lg{.c7n-pro-switch-label{min-width:", "px;height:", "px;line-height:", "px;::after{width:", "px;height:", "px;}}}}}"], defaultSize * 2, defaultSize, defaultSize, labelBgColor, defaultSize / 2, defaultSize - 4, defaultSize - 4, labelAfterBgColor, primary, labelAfterBgColor, primary, smSize * 2, smSize, smSize, smSize - 4, smSize - 4, lgSize * 2, lgSize, lgSize, lgSize - 4, lgSize - 4);
};
var H0SwitchStyle = function H0SwitchStyle(props) {
  var _getThemeData3 = getThemeData(props, 'common'),
    primary6 = _getThemeData3.primary6;
  return css([".ant-switch.ant-switch-checked{background-color:", ";color:#fff;&::after{background-color:#fff;}}"], primary6);
};
var switchData = {
  name: 'switch',
  data: [{
    labelBgColor: 'rgba(0,0,0,0.25)',
    labelAfterBgColor: '#fff',
    defaultSize: 22,
    smSize: 18,
    lgSize: 24
  }],
  onlyTemplate: {
    pro: C7nSwitchStyle,
    hzero: H0SwitchStyle
  }
};
export default switchData;